var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('layout-header'),_c('div',{staticClass:"page-content"},[_c('layout-sidebar'),_c('div',{staticClass:"content-wrapper"},[_c('layout-page-header'),_c('div',{staticClass:"content"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('layout-footer')],1)],1),_c('vue-snotify')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }